module.exports = __webpack_public_path__ + "images/section-bg-54-small.webp";